// extracted by mini-css-extract-plugin
module.exports = {"badLinkWarning":"LenkeBase_badLinkWarning__smT_c"};